import { useState, useRef } from "react";

const editingStates = new Map();

export function useEditableState(cellKey, options) {
	const getPersistedState = () =>
		editingStates.get(cellKey) || {
			isEditing: false,
			selectedValue: null,
			dynamicOptions: options,
		};

	const setPersistedState = (newState) => editingStates.set(cellKey, { ...getPersistedState(), ...newState });

	const persistedState = getPersistedState();

	const [isEditing, setIsEditingState] = useState(() => persistedState.isEditing);
	const [selectedValue, setSelectedValueState] = useState(() => persistedState.selectedValue);
	const [isSaving, setIsSaving] = useState(false);
	const [errorText, setErrorText] = useState("");
	const [dynamicOptions, setDynamicOptionsState] = useState(() => persistedState.dynamicOptions || options);
	const [menuIsOpen, setMenuIsOpen] = useState(false);

	const selectRef = useRef(null);
	const isMountedRef = useRef(false);
	const abortRef = useRef(null);
	const containerRef = useRef(null);

	const setIsEditing = (value) => {
		setIsEditingState(value);
		setPersistedState({ isEditing: value });
	};

	const setSelectedValue = (value) => {
		setSelectedValueState(value);
		setPersistedState({ selectedValue: value });
	};

	const setDynamicOptions = (value) => {
		const newOptions = typeof value === "function" ? value(getPersistedState().dynamicOptions || options) : value;
		setDynamicOptionsState(newOptions);
		setPersistedState({ dynamicOptions: newOptions });
	};

	const clearPersistedState = () => {
		editingStates.delete(cellKey);
	};

	return {
		isEditing,
		setIsEditing,
		setIsEditingState,
		selectedValue,
		setSelectedValue,
		isSaving,
		setIsSaving,
		errorText,
		setErrorText,
		dynamicOptions,
		setDynamicOptions,
		menuIsOpen,
		setMenuIsOpen,
		selectRef,
		isMountedRef,
		abortRef,
		containerRef,
		clearPersistedState,
	};
}
